import { render, staticRenderFns } from "./appLayoutFooter.vue?vue&type=template&id=3e80968e"
import script from "./appLayoutFooter.vue?vue&type=script&lang=js"
export * from "./appLayoutFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports